export default class {

  constructor() {
    this.owner = '';
    this.product = {};
    this.qty = 1;
    this.weight = {};
    this.size = {};
    this.shoeSize = {};
    this.equipments = [];
  }

  hydrate(data) {
    if (data.owner) this.owner = data.owner;
    if (data.product) this.product = data.product;
    if (data.qty) this.qty = data.qty;
    if (data.weight) this.weight = data.weight;
    if (data.size) this.size = data.size;
    if (data.shoeSize) this.shoeSize = data.shoeSize;
    if (data.equipments && data.equipments.length) this.equipments = data.equipments;
  }
}
